<ng-container *ngIf="!isHaveToBeHidden; else noValue">
  <cms-yes-no [yes]="valueCastedToBoolean"></cms-yes-no>
</ng-container>
<ng-template #noValue>—</ng-template>
